module.exports = __webpack_public_path__ + "static/media/crehana-white.94ca2098.svg";